var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"content w-1400"},[_c('div',{staticClass:"logo-word"}),_c('login-box',{attrs:{"show-home":true},on:{"changeOrder":_vm.changeOrder}})],1),_c('Post_Inquiry',{attrs:{"dialogVisible":_vm.showInquiry},on:{"close":function($event){return _vm.changeOrder(false)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }